<footer>
	<div class="footer-container">
		<img src="https://www.bumblebeestudio.net/smartees/wp-content/uploads/2017/11/EU_flag.png"/>&nbsp;
		<p>This project has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement No. 761496.</p>
	</div>
</footer>
